@if (!success()) {
  <homey-page-title title="Forgot password"/>
  <p class="mb-4">Enter your email and we'll send you a link to get back into your account.</p>
  @if (error()) {
    <p-message icon="pi pi-times-circle" severity="error" class="block mb-4">
      {{ error() }}
    </p-message>
  }
  <homey-custom-form [formGroup]="form" submitButtonLabel="Send" [submitFunction]="submit">
    <homey-text-input [inputFormControl]="form.controls.email"
                      inputId="email"
                      label="Email address"
                      type="email"/>
  </homey-custom-form>
} @else {
  <homey-page-title title="Thank you!"/>
  <p>If there was an account linked to <span class="font-medium">{{form.value.email}}</span> we've sent you an email with a link to reset your password.</p>
  <p class="mt-4">Don’t forget to check your “Spam”, “Notification, “Newsletter”, “Social”... folders if you don’t see the email in your inbox.</p>
}
